import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function FranceAgriMerPage() {
  const aide = getAideAgricoleStub('franceagrimer');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
